import { colors, greys, theme } from "@clockwise/web-commons/src/styles/color.styles";
import spacing from "@clockwise/web-commons/src/styles/spacing.styles";
import { fontFamily } from "@clockwise/web-commons/src/styles/type.styles";
import { CSSProperties } from "react";

export const timeIcon = {
  style: {
    marginRight: spacing.sm,
    width: 20,
  } as CSSProperties,
  htmlColor: greys.slate,
};

export const error: CSSProperties = {
  fontSize: 12,
  lineHeight: 1,
  color: colors.red.bright,
  marginTop: spacing.xs,
};

export const viewModeRow: CSSProperties = {
  cursor: "pointer",
};

export const tags: CSSProperties = {
  fontSize: 12,
  lineHeight: 2,
  fontWeight: 600,
  fontFamily: fontFamily,
};
export const date: CSSProperties = {
  fontSize: 14,
  lineHeight: 1.5,
  marginBottom: 3,
  color: greys.darkestGrey,
};

export const best: CSSProperties = {
  color: colors.green.darker,
};

export const score: CSSProperties = {
  fontSize: 14,
  lineHeight: 1.5,
  color: greys.darkestGrey,
};

export const stat: CSSProperties = {
  fontWeight: 600,
};

export const warning: CSSProperties = {
  marginTop: 5,
  fontSize: 12,
  lineHeight: 1.5,
  color: colors.peach.darker,
  display: "flex",
  flexDirection: "row",
  alignItems: "flex-start",
};

export const warningIcon = {
  style: {
    height: 18,
    width: 18,
    marginRight: 10,
  } as CSSProperties,
  htmlColor: colors.peach.darker,
};

// EDIT MODE
export const editModeContainer: CSSProperties = {
  height: "100%",
  width: "100%",
  position: "absolute",
  zIndex: 3,
  top: 0,
  display: "flex",
  flexDirection: "column",
  backgroundColor: greys.white,
  padding: `${spacing.sm}px 0 ${spacing.sm}px 0px`,
};

export const rangeAndDurationContainer: CSSProperties = {
  display: "flex",
  alignItems: "center",
  borderBottom: `1px solid ${greys.paleGrey}`,
};

export const duration = {
  container: {
    display: "flex",
    alignItems: "center",
    marginLeft: -2,
  } as CSSProperties,
  icon: {
    color: theme.textSecondary,
    width: 16,
    height: 16,
    marginLeft: 2,
    marginRight: 10,
    marginTop: 3,
    flexShrink: 0,
    flexGrow: 1,
  } as CSSProperties,
};

export const dateRangePicker: CSSProperties = {
  flexGrow: 2,
  maxWidth: 130,
};

export const room = {
  container: {
    display: "flex",
    alignItems: "center",
    borderBottom: `1px solid ${greys.paleGrey}`,
    padding: "5px 0",
    marginBottom: 14,
  } as CSSProperties,
  icon: {
    color: theme.textSecondary,
    width: 16,
    height: 16,
    marginLeft: 2,
    marginRight: 10,
    marginTop: 3,
    flexShrink: 0,
    flexGrow: 1,
  } as CSSProperties,
};

export const businessIcon = {
  style: {
    height: 18,
    width: 18,
    marginRight: 10,
    marginLeft: 3,
    flexShrink: 0,
  } as CSSProperties,
  htmlColor: greys.slate,
};

export const conflictResolution = {
  container: {
    display: "flex",
    borderBottom: `1px solid ${greys.paleGrey}`,
    padding: "5px 0",
    alignItems: "center",
  } as CSSProperties,
  label: {
    marginLeft: 10,
    color: greys.slate,
  },
};

export const conflictResolutionIcon = {
  style: {
    height: 18,
    width: 18,
    marginRight: 10,
    flexShrink: 0,
  } as CSSProperties,
  htmlColor: greys.slate,
};

export const underlineStyle: CSSProperties = {
  visibility: "hidden",
};

export const buttonContainer: CSSProperties = {
  bottom: 0,
  background: greys.white,
  padding: "15px 15px 0px 8px",
};
